import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
  squareTriangleFullBgMp4,
  squareTriangleFullWebm,
  squareTriangleLoopBgMp4,
  squareTriangleLoopWebm,
} from '../../assets/videos';
import { VideoWithLoop } from '../../components/VideoWithLoop';
import { SITE_LINKS } from '../../constants';
import { Background } from '../../stories/Background';
import { Button } from '../../stories/Button';
import { Header } from '../../stories/Header';

export const OnboardingWelcomePage: React.FC = () => {
  const __ = useTranslation().t;
  return (
    <>
      <Header type="logo-only" />
      <Background>
        <Container>
          <div className="oejr-page-onboarding oejr-page-onboarding-0">
            <h1 className="oejr-onboarding-main-argument">{__('welcomeOpenEnglishJunior')}</h1>
            <h1>{__('firstStepsOnThePlatform')}</h1>
            <p>{__('onboardingWithStudent')}</p>
            <Button
              className="oejr-onboarding-button"
              icon="arrow-right"
              label={__('getStarted')}
              href={SITE_LINKS.OnboardingPage(`recommendations`)}
              variant="primary"
              size="lg"
            />
            <VideoWithLoop
              video1Mp4={squareTriangleFullBgMp4}
              video1Webm={squareTriangleFullWebm}
              video2Mp4={squareTriangleLoopBgMp4}
              video2Webm={squareTriangleLoopWebm}
            />
          </div>
        </Container>
      </Background>
    </>
  );
};
